<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="使用平台">
            <a-select
              v-model="searchForm.line_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择使用平台"
              style="width: 100%"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建人员">
            <a-input v-model="searchForm.created_name" allowClear placeholder="请输入创建人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新人员">
            <a-input v-model="searchForm.updated_name" allowClear placeholder="请输入更新人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select
              v-model="searchForm.state"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择状态"
              style="width: 100%"
            >
              <a-select-option value="1">
                开启
              </a-select-option>
              <a-select-option value="2">
                关闭
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建时间">
            <v-range-picker v-model="searchForm.created_at" allowClear @change="onCreateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新时间">
            <v-range-picker v-model="searchForm.updated_at" @change="onUpdateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="弹窗类型">
            <a-select
              v-model="searchForm.popup_type"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择弹窗类型"
              style="width: 100%"
            >
              <a-select-option v-for="item in FREQUENCY_CONFIG_POPUP_TYPE" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" ghost icon="delete" @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      size="middle"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :scroll="{ x: true }"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
    >
      <template slot="user_id" slot-scope="text, record"> {{ record.user_name | fillBlank }} ({{ text }}) </template>
      <template slot="project" slot-scope="text, record">
        <span>{{ getOrg(record) }}</span>
      </template>
      <template slot="popup_type" slot-scope="text">
        <span>{{ showName('FREQUENCY_CONFIG_POPUP_TYPE', text) }}</span>
      </template>
      <template slot="user_id" slot-scope="text, record">
        <p style="margin:0;">创建：{{ record.created_name }}({{ record.created_number }})</p>
        <p style="margin:0;">更新：{{ record.updated_name }}({{ record.updated_number }})</p>
      </template>
      <template slot="create_at" slot-scope="text, record">
        <p style="margin:0;">创建：{{ time(record.created_at) }}</p>
        <p style="margin:0;">更新：{{ time(record.updated_at) }}</p>
      </template>
      <template slot="state" slot-scope="text, record">
        <a-switch :checked="format(record.state)" checked-children="开" un-checked-children="关" @change="(val)=>checkedChange(val, record)"/>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-sb">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" danger @click="handleTableCommand('delete', record)">删除</a-button>
        </div>
      </template>
    </a-table>
    <!-- 添加 -->
    <addFrequency v-if="visible" v-model="visible" :isEdit="isEdit" :platformList="platformList" :params="waitItem" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, columns } from './business/frequencySet'
import pagination from '@/composables/pagination'
import addFrequency from './addFrequency.vue'
import compuedFun from '../../computed/'
import api from '@/api/'
import moment from 'moment'
export default {
      components: { addFrequency },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm },
    })

    onMounted(async () => {
      await methods.getList()
      methods.getPlatform()
    })

    const methods = {
        onUpdateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.updated_at = []
          return
        }
        _this.searchForm.updated_at = [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
        onCreateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.created_at = []
          return
        }
        _this.searchForm.created_at = [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
    time(time) {
        return (time = moment(time * 1000).format('YYYY-MM-DD HH:mm:ss'))
      },
      search() {
        _this.pagination.current = 1
        this.getList()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
            // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      checkedChange(val, record) {
        const params = { id: record.id, state: val ? 1 : 2 }
        api.frequencyConfigUpdate(params).then((res) => {
          if (res.code === '000000') {
            record.state = val
            this.getList()
          } else {
            record.state = !val
          }
        })
        .catch(() => {
          record.state = !val
        })
      },
      async getList() {
        _this.loading = true
        const [start_date, end_date] = state.times
        _this.searchForm.start_date = start_date
        _this.searchForm.end_date = end_date
        const res = await api.frequencyConfigList({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const frequencyList = res?.data?.list || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = frequencyList
        //  _this.data = frequencyList.map(item => {
        //   item.state = Number(item.state) === 1
        //   return item
        // })
        _this.pagination.total = pagination.total
        _this.loading = false
      },
      getOrg(record) {
        const obj = _this.platformList.find(
          (item) =>
            Number(item.project) === Number(record.project) &&
            Number(item.staff_style) === Number(record.staff_style) &&
            Number(item.type) === Number(record.type)
        )
        return obj ? obj.org : ''
      },
      async getPlatform() {
        const res = await api.LineList()
        state.platformList = res.data
      },
      changeIsShow(params) {
        api.updateInterviewIsShow(params).then((res) => {
          this.getList()
        })
      },
      format(value) {
        return value === 1
      },
      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods,
    }
  },
}
</script>
